// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import Body from 'components/text/Body';

const AdminDataRow = ({ label, children }) => (
  <div>
    <Body>
      {' '}
      <strong>{label}:</strong> {children}
    </Body>
  </div>
);

export default AdminDataRow;



// WEBPACK FOOTER //
// ./src/components/common/AdminDataRow/index.js